import { LabelSelectionGroup } from '../../../../store';

interface EditLabelGroupControlsProps {
  currentLabelGroup: LabelSelectionGroup | null;
  groupName: string;
  groupColor: string;
  canSaveSelectionGroup: boolean;
  onGroupNameChange: (value: string) => void;
  onGroupColorChange: (value: string) => void;
  onManageGroups: () => void;
  onSaveGroup: () => void;
}

function formatCurrentGroupSummary(currentLabelGroup: LabelSelectionGroup | null) {
  if (!currentLabelGroup) {
    return 'Not in a group';
  }

  const labelCount = currentLabelGroup.labelIds.length;
  return `${currentLabelGroup.name} (${labelCount} label${labelCount === 1 ? '' : 's'})`;
}

export function EditLabelGroupControls({
  currentLabelGroup,
  groupName,
  groupColor,
  canSaveSelectionGroup,
  onGroupNameChange,
  onGroupColorChange,
  onManageGroups,
  onSaveGroup,
}: EditLabelGroupControlsProps) {
  return (
    <>
      {!currentLabelGroup && (
        <>
          <label className="theme-select label-editor-form__group-name-field">
            <span className="theme-select__label">Save selection as group</span>
            <input
              aria-label="Selection group name"
              className="theme-select__control"
              value={groupName}
              onChange={(e) => onGroupNameChange(e.target.value)}
              placeholder="e.g. Main entrances"
            />
          </label>
          <label className="theme-color">
            <div className="theme-color__text">
              <span className="theme-color__label">Group colour</span>
            </div>
            <div className="theme-color__control">
              <input
                aria-label="Selection group colour"
                type="color"
                value={groupColor}
                onChange={(e) => onGroupColorChange(e.target.value)}
              />
              <span className="theme-color__value">{groupColor}</span>
            </div>
          </label>
          <div className="label-editor-form__actions">
            <button
              className="label-editor-form__secondary-button"
              type="button"
              onClick={onSaveGroup}
              disabled={!canSaveSelectionGroup}
            >
              Save group
            </button>
          </div>
        </>
      )}
      <div className="label-editor-form__actions label-editor-form__actions--group-summary">
        <div className="theme-select label-editor-form__group-name-field">
          <span className="theme-select__label">Current group</span>
          <div className="theme-select__control label-editor-form__group-summary-value">
            {formatCurrentGroupSummary(currentLabelGroup)}
          </div>
        </div>
        <button
          className="label-editor-form__secondary-button"
          type="button"
          onClick={onManageGroups}
        >
          Manage groups
        </button>
      </div>
    </>
  );
}

export default EditLabelGroupControls;
